import { createSlice } from '@reduxjs/toolkit'
import { apiCallBegan } from '../api'
import { lookupInitialState as initialState } from '../initialState/lookupState'


const slice = createSlice({
  name: 'lookup',
  initialState,
  reducers: {
    lookupDataReceived: (lookup, action) => {
        let lookupResponse = action.payload.response;
        lookup.loading = false;
        lookup = addLookupData(lookup, lookupResponse);
      },
    lookupDataRequestFailed: (lookup, action) => {
        lookup.errorMessage = "Lookup data request failed";
        lookup.loading = false;
      },
    lookupDataRequested: (lookup, action) => {
        lookup.loading = true;
      },
    scanRulelookupDataReceived: (lookup, action) => {
        let lookupResponse = action.payload.response;
        lookup.loading = false;
        lookup = addLookupData(lookup, lookupResponse);
      },
    scanRulelookupDataRequestFailed: (lookup, action) => {
        lookup.errorMessage = "Scan Rule Lookup data request failed";
        lookup.loading = false;
      },
    scanRulelookupDataRequested: (lookup, action) => {
        lookup.loading = true;
      },

    scanRuleMMlookupDataReceived: (lookup, action) => {
        let lookupResponse = action.payload.response;
        lookup.loading = false;
        lookup = addLookupData(lookup, lookupResponse);
      },
    scanRuleMMlookupDataRequestFailed: (lookup, action) => {
        lookup.errorMessage = "MM Brand Protection Lookup data request failed";
        lookup.loading = false;
      },
    scanRuleMMlookupDataRequested: (lookup, action) => {
        lookup.loading = true;
      },

    mmImageSizelookupDataReceived: (lookup, action) => {
        let lookupResponse = action.payload.response;
        lookup.loading = false;
        lookup = addLookupData(lookup, lookupResponse);
      },
    
    mmImageSizelookupDataRequestFailed: (lookup, action) => {
        lookup.errorMessage = "MM Image Size Lookup data request failed";
        lookup.loading = false;
      },
    
    mmImageSizelookupDataRequested: (lookup, action) => {
        lookup.loading = true;
      },

    industrylookupDataReceived: (lookup, action) => {
        let lookupResponse = action.payload.response;
        lookup.loading = false;
        lookup = addIndustryLookupData(lookup, lookupResponse);
    },
    industrylookupDataRequestFailed: (lookup, action) => {
        lookup.errorMessage = "Industry Lookup data request failed";
        lookup.loading = false;
      },
    industrylookupDataRequested: (lookup, action) => {
        lookup.loading = true;
      },
    countrylookupDataReceived: (lookup, action) => {
        let lookupResponse = action.payload.response;
        lookup.loading = false;
        lookup = addCountryLookupData(lookup, lookupResponse);
    },
    countrylookupDataRequestFailed: (lookup, action) => {
        lookup.errorMessage = "Country Lookup data request failed";
        lookup.loading = false;
    },
    countrylookupDataRequested: (lookup, action) => {
        lookup.loading = true;
    },
    statelookupDataReceived: (lookup, action) => {
        let lookupResponse = action.payload.response;
        lookup.loading = false;
        lookup = addStateLookupData(lookup, lookupResponse);
    },
    statelookupDataRequestFailed: (lookup, action) => {
        lookup.errorMessage = "State Lookup data request failed";
        lookup.loading = false;
    },
    statelookupDataRequested: (lookup, action) => {
        lookup.loading = true;
    },
    citylookupDataReceived: (lookup, action) => {
        let lookupResponse = action.payload.response;
        lookup.loading = false;
        lookup = addCityLookupData(lookup, lookupResponse);
    },
    citylookupDataRequestFailed: (lookup, action) => {
        lookup.errorMessage = "City Lookup data request failed";
        lookup.loading = false;
    },
    citylookupDataRequested: (lookup, action) => {
        lookup.loading = true;
    },
    licenseTypeLookupDataReceived: (lookup, action) => {
        let lookupResponse = action.payload.response;
        lookup.loading = false;
        lookup = addLookupData(lookup, lookupResponse);
      },
    licenseTypeLookupDataRequestFailed: (lookup, action) => {
        lookup.errorMessage = "Lookup data request failed";
        lookup.loading = false;
      },
    licenseTypeLookupDataRequested: (lookup, action) => {
        lookup.loading = true;
      },
    actionLookupDataReceived: (lookup, action) => {
        let lookupResponse = action.payload.response;
        lookup.loading = false;
        lookup = addActionLookupData(lookup, lookupResponse);
      },
    actionLookupDataRequestFailed: (lookup, action) => {
        lookup.errorMessage = "Action Lookup data request failed";
        lookup.loading = false;
      },
    actionLookupDataRequested: (lookup, action) => {
        lookup.loading = true;
      },

    govCategoryLookupDataReceived: (lookup, action) => {
        lookup.loading = false;
        lookup = addToGovArray(lookup, 'govCategories', action.payload.response);
      },
    govCategoryLookupDataRequestFailed: (lookup) => { lookup.loading = false; },
    govCategoryLookupDataRequested: (lookup) => { lookup.loading = true; },

    govOperatorLookupDataReceived: (lookup, action) => {
        lookup.loading = false;
        lookup = addToGovArray(lookup, 'govOperators', action.payload.response);
      },
    govOperatorLookupDataRequestFailed: (lookup) => { lookup.loading = false; },
    govOperatorLookupDataRequested: (lookup) => { lookup.loading = true; },

    govVersionStatusLookupDataReceived: (lookup, action) => {
        lookup.loading = false;
        lookup = addToGovArray(lookup, 'govVersionStatuses', action.payload.response);
      },
    govVersionStatusLookupDataRequestFailed: (lookup) => { lookup.loading = false; },
    govVersionStatusLookupDataRequested: (lookup) => { lookup.loading = true; },

    govFileDirectionLookupDataReceived: (lookup, action) => {
        lookup.loading = false;
        lookup = addToGovArray(lookup, 'govFileDirections', action.payload.response);
      },
    govFileDirectionLookupDataRequestFailed: (lookup) => { lookup.loading = false; },
    govFileDirectionLookupDataRequested: (lookup) => { lookup.loading = true; },

    govFileRuleTypeLookupDataReceived: (lookup, action) => {
        lookup.loading = false;
        lookup = addToGovArray(lookup, 'govFileRuleTypes', action.payload.response);
      },
    govFileRuleTypeLookupDataRequestFailed: (lookup) => { lookup.loading = false; },
    govFileRuleTypeLookupDataRequested: (lookup) => { lookup.loading = true; },

    govAppDispositionLookupDataReceived: (lookup, action) => {
        lookup.loading = false;
        lookup = addToGovArray(lookup, 'govAppDispositions', action.payload.response);
      },
    govAppDispositionLookupDataRequestFailed: (lookup) => { lookup.loading = false; },
    govAppDispositionLookupDataRequested: (lookup) => { lookup.loading = true; },
  }

})

export const {
    govCategoryLookupDataReceived,
    govCategoryLookupDataRequested,
    govCategoryLookupDataRequestFailed,
    govOperatorLookupDataReceived,
    govOperatorLookupDataRequested,
    govOperatorLookupDataRequestFailed,
    govVersionStatusLookupDataReceived,
    govVersionStatusLookupDataRequested,
    govVersionStatusLookupDataRequestFailed,
    govFileDirectionLookupDataReceived,
    govFileDirectionLookupDataRequested,
    govFileDirectionLookupDataRequestFailed,
    govFileRuleTypeLookupDataReceived,
    govFileRuleTypeLookupDataRequested,
    govFileRuleTypeLookupDataRequestFailed,
    govAppDispositionLookupDataReceived,
    govAppDispositionLookupDataRequested,
    govAppDispositionLookupDataRequestFailed,
    lookupDataReceived,
    lookupDataRequested,
    lookupDataRequestFailed,
    scanRulelookupDataReceived,
    scanRulelookupDataRequested,
    scanRulelookupDataRequestFailed,
    scanRuleMMlookupDataReceived,
    scanRuleMMlookupDataRequested,
    scanRuleMMlookupDataRequestFailed,
    mmImageSizelookupDataRequested,
    mmImageSizelookupDataReceived,
    mmImageSizelookupDataRequestFailed,
    industrylookupDataReceived,
    industrylookupDataRequested,
    industrylookupDataRequestFailed,
    countrylookupDataReceived,
    countrylookupDataRequested,
    countrylookupDataRequestFailed,
    statelookupDataReceived,
    statelookupDataRequested,
    statelookupDataRequestFailed,
    citylookupDataReceived,
    citylookupDataRequested,
    citylookupDataRequestFailed,
    licenseTypeLookupDataReceived,
    licenseTypeLookupDataRequested,
    licenseTypeLookupDataRequestFailed,
    actionLookupDataReceived,
    actionLookupDataRequested,
    actionLookupDataRequestFailed,
 } = slice.actions

export default slice.reducer

export const getLookupData = () => {
    return apiCallBegan({
      urlPath: `/lookup/LKP_SRVC_TYPE`,
      method: 'GET',
      onStart: lookupDataRequested.type,
      onSuccess: lookupDataReceived.type,
      onError: lookupDataRequestFailed.type,
    })
  }

export const getScanRuleLookupData = () => {
    return apiCallBegan({
      urlPath: `/lookup/LKP_SCANNING_RULE`,
      method: 'GET',
      onStart: scanRulelookupDataRequested.type,
      onSuccess: scanRulelookupDataReceived.type,
      onError: scanRulelookupDataRequestFailed.type,
    })
  }

  export const getMMScanPolicyLookupData = () => {
    return apiCallBegan({
      urlPath: `/lookup/LKP_MM_SCANPOLICY`,
      method: 'GET',
      onStart: scanRuleMMlookupDataRequested.type,
      onSuccess: scanRuleMMlookupDataReceived.type,
      onError: scanRuleMMlookupDataRequestFailed.type,
    })
  }

  export const getMMImageSizeLookupData = () => {
    return apiCallBegan({
      urlPath: `/lookup/LKP_MM_IMG_SIZE`,
      method: 'GET',
      onStart: mmImageSizelookupDataRequested.type,
      onSuccess: mmImageSizelookupDataReceived.type,
      onError: mmImageSizelookupDataRequestFailed.type,
    })
  }

  export const getIndustryLookupData = () => {
    return apiCallBegan({
      urlPath: `/lookup/LKP_INDUSTRY`,
      method: 'GET',
      onStart: industrylookupDataRequested.type,
      onSuccess: industrylookupDataReceived.type,
      onError: industrylookupDataRequestFailed.type,
    })
  }

  export const getCountryLookupData = () => {
    return apiCallBegan({
      urlPath: `/lookup/LKP_COUNTRY`,
      method: 'GET',
      onStart: countrylookupDataRequested.type,
      onSuccess: countrylookupDataReceived.type,
      onError: countrylookupDataRequestFailed.type,
    })
  }

  export const getStateLookupData = (countryCode) => {
    return apiCallBegan({
      urlPath: `/lookup/LKP_STATE?sflex1=${countryCode}`,
      method: 'GET',
      onStart: statelookupDataRequested.type,
      onSuccess: statelookupDataReceived.type,
      onError: statelookupDataRequestFailed.type,
    })
  }

  export const getCityLookupData = (stateCode, countryCode) => {
    return apiCallBegan({
      urlPath: `/lookup/LKP_CITY?sflex1=${countryCode}&sflex2=${stateCode}`,
      method: 'GET',
      onStart: citylookupDataRequested.type,
      onSuccess: citylookupDataReceived.type,
      onError: citylookupDataRequestFailed.type,
    })
  }

  export const getLicenseTypeLookupData = () => {
    return apiCallBegan({
      urlPath: `/lookup/LKP_LICENSE_TYPE`,
      method: 'GET',
      onStart: licenseTypeLookupDataRequested.type,
      onSuccess: licenseTypeLookupDataReceived.type,
      onError: licenseTypeLookupDataRequestFailed.type,
    })
  }

  export const getActionLookupData = () => {
    return apiCallBegan({
      urlPath: `/lookup/LKP_GOV_ACTION`,
      method: 'GET',
      onStart: actionLookupDataRequested.type,
      onSuccess: actionLookupDataReceived.type,
      onError: actionLookupDataRequestFailed.type,
    })
  }

const addActionLookupData = (lookup, lookupResponse) => {
    if(lookupResponse.errors.length > 0){
        lookup.errorMessage = lookupResponse.errors[0].desc;
    }
    else {
        lookupResponse.data.forEach((element) => {
          if(!lookup.actions.some(item => item.code === element.code)){
            lookup.actions.push(element);
        } });
    }
    return lookup;
  }

  const addLookupData = (lookup, lookupResponse) => {
    if(lookupResponse.errors.length > 0){
        lookup.errorMessage = lookupResponse.errors[0].desc;
    }
    else {
        lookupResponse.data.forEach((element) => {
          if(!lookup.data.some(item => item.code === element.code)){
            lookup.data.push(element);
        } });
    }
    return lookup;
  }

const addIndustryLookupData = (lookup, lookupResponse) => {
    if(lookupResponse.errors.length > 0){
        lookup.errorMessage = lookupResponse.errors[0].desc;
    }
    else {
        lookupResponse.data.forEach((element) => {
          if(!lookup.industries.some(item => item.code === element.code)){
            lookup.industries.push(element);
        } });
    }
    return lookup;
  }

const addCountryLookupData = (lookup, lookupResponse) => {
    if(lookupResponse.errors.length > 0){
        lookup.errorMessage = lookupResponse.errors[0].desc;
    }
    else {
        lookupResponse.data.forEach((element) => {
          if(!lookup.countries.some(item => item.code === element.code)){
            lookup.countries.push(element);
        } });
    }
    return lookup;
  }

const addStateLookupData = (lookup, lookupResponse) => {
    if(lookupResponse.errors.length > 0){
        lookup.errorMessage = lookupResponse.errors[0].desc;
    }
    else {
        lookupResponse.data.forEach((element) => {
          if(!lookup.states.some(item => item.code === element.code)){
            lookup.states.push(element);
        } });
    }
    return lookup;
  }

const addCityLookupData = (lookup, lookupResponse) => {
    if(lookupResponse.errors.length > 0){
        lookup.errorMessage = lookupResponse.errors[0].desc;
    }
    else {
        lookupResponse.data.forEach((element) => {
          if(!lookup.cities.some(item => item.code === element.code)){
            lookup.cities.push(element);
        } });
    }
    return lookup;
  }

const addToGovArray = (lookup, arrayName, lookupResponse) => {
    if (lookupResponse.errors && lookupResponse.errors.length > 0) {
        lookup.errorMessage = lookupResponse.errors[0].desc;
    } else {
        (lookupResponse.data || []).forEach((element) => {
            if (!lookup[arrayName].some(item => item.code === element.code)) {
                lookup[arrayName].push(element);
            }
        });
    }
    return lookup;
}

export const getGovCategoryLookupData = () => apiCallBegan({
    urlPath: `/lookup/LKP_GOV_DATA_CATEGORY`, method: 'GET',
    onStart: govCategoryLookupDataRequested.type,
    onSuccess: govCategoryLookupDataReceived.type,
    onError: govCategoryLookupDataRequestFailed.type,
})

export const getGovOperatorLookupData = () => apiCallBegan({
    urlPath: `/lookup/LKP_GOV_OPERATOR`, method: 'GET',
    onStart: govOperatorLookupDataRequested.type,
    onSuccess: govOperatorLookupDataReceived.type,
    onError: govOperatorLookupDataRequestFailed.type,
})

export const getGovVersionStatusLookupData = () => apiCallBegan({
    urlPath: `/lookup/LKP_GOV_VERSION_STATUS`, method: 'GET',
    onStart: govVersionStatusLookupDataRequested.type,
    onSuccess: govVersionStatusLookupDataReceived.type,
    onError: govVersionStatusLookupDataRequestFailed.type,
})

export const getGovFileDirectionLookupData = () => apiCallBegan({
    urlPath: `/lookup/LKP_GOV_FILE_DIRECTION`, method: 'GET',
    onStart: govFileDirectionLookupDataRequested.type,
    onSuccess: govFileDirectionLookupDataReceived.type,
    onError: govFileDirectionLookupDataRequestFailed.type,
})

export const getGovFileRuleTypeLookupData = () => apiCallBegan({
    urlPath: `/lookup/LKP_GOV_FILE_RULE_TYPE`, method: 'GET',
    onStart: govFileRuleTypeLookupDataRequested.type,
    onSuccess: govFileRuleTypeLookupDataReceived.type,
    onError: govFileRuleTypeLookupDataRequestFailed.type,
})

// App disposition (SANCTIONED | UNSANCTIONED | DENIED) — drives the Web/AI
// disposition dropdown. Mirrors the govCategory lookup pattern.
export const getGovAppDispositionLookupData = () => apiCallBegan({
    urlPath: `/lookup/LKP_GOV_APP_DISPOSITION`, method: 'GET',
    onStart: govAppDispositionLookupDataRequested.type,
    onSuccess: govAppDispositionLookupDataReceived.type,
    onError: govAppDispositionLookupDataRequestFailed.type,
})